<template>
  <div class="app">
    <el-config-provider :locale="locale === 'zh_HK' ? zhHk : locale === 'zh_CN' ? zhCN : en">
      <router-view />
    </el-config-provider>
  </div>
</template>
<script setup lang="ts">
import { onBeforeMount, onMounted, onUnmounted } from "vue";
import en from "element-plus/es/locale/lang/en";
import zhHk from "element-plus/es/locale/lang/zh-hk";
import zhCN from "element-plus/es/locale/lang/zh-cn";
import "@/mobile.scss";
import { useChangeLanguage } from "@/hooks/useLanguageEnum";
import { useUserInfo } from "@/stores/user";
import { cleanupCrossTabSync, initCrossTabSync } from "@/libs/crossTabSync";

const { locale } = useChangeLanguage();
const userStore = useUserInfo();

onBeforeMount(async () => {
  initCrossTabSync();

  await userStore.initializeUser();
});
onUnmounted(() => {
  cleanupCrossTabSync();
});

onMounted(() => {
  // const str = "Hel%s%s %sor%s%s%s";
  // const num1 =1.523, num2 = -0.52;
  // console.log(str._format("l","o","w","d"));
  // console.log(num1._fpo(num2,2))
});
</script>
<style scoped lang="scss">
@use "@/theme.scss" as theme;

.app {
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  background: #f2f9ff;
}

.layout {
  padding: 0;
  margin: 0;
  overflow-y: hidden;
  height: calc(100vh - env(safe-area-inset-bottom, 20px) - env(safe-area-inset-top, 20px));
  font-family: MicrosoftYaHei, "Noto Sans SC", Roboto, "Helvetica Neue", Agency FB, Batang, ui-serif,
    sans-serif, system-ui, monospace, fangsong;
  background-color: #f0f4ff;
  background-repeat: repeat;
  background-position: left top;
  background-size: 100px 100px;
  --el-input-border-color: #999;
  --el-checkbox-checked-input-border-color: #333;
  --el-input-focus-border: #704fe6;

  --el-segmented-item-selected-color: var(--el-text-color-primary);
  --el-border-radius-base: 6px;
  --el-checkbox-checked-bg-color: #fff;
  --el-color-primary: #704fe6;
}

:deep(.el-textarea) {
  --el-input-focus-border: theme.$main-active-font-color;
}

:deep(label.el-segmented__item.is-selected) {
  background-color: theme.$main-active-font-color;
}

:deep(.el-input__wrapper.is-focus) {
  box-shadow: none;
}

:deep(.el-select-dropdown__item.selected) {
  color: theme.$main-active-font-color !important;
}

:deep(.el-select .is-focus .el-input__wrapper) {
  box-shadow: none;
}

:deep(.el-select__wrapper.is-focused) {
  box-shadow: none;
}

.layout:deep(.el-pager li.is-active) {
  border-radius: 50%;
}

:deep(.el-pagination.is-background .el-pager li) {
  background-color: transparent;
}

:deep(.el-segmented__item) {
  border-radius: 10px;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
  background-color: theme.$main-active-font-color;
  border-radius: 50%;
  color: #fff;
}

:deep(.el-pagination.is-background) {
  background-color: transparent;
}

:deep(.el-loading-mask) {
  background-color: transparent;
}

:deep(.el-pagination.is-background .btn-prev) {
  background-color: transparent;
}

:deep(.el-pagination.is-background .btn-prev:disabled) {
  background-color: transparent;
}

:deep(.el-pagination.is-background .btn-next) {
  background-color: transparent;
}

:deep(.el-pagination.is-background .btn-next) {
  background-color: transparent;
}

:deep(.el-pagination.is-background .btn-next:disabled) {
  background-color: transparent;
}

:deep(.el-date-table-cell__text) {
  background-color: #2c3e50;
  color: #9b1ce5;
}

.locale-zh {
  --menu-widh: 220px;
}

.locale-en {
  --menu-widh: 275px;
}

.alert-wrapper {
  position: fixed;
  left: 40vw;
  right: 40vw;
  top: 15vh;
  z-index: 99999;
  min-width: 280px;
}

.main {
  padding: 20px 20px 0 20px;
  background-color: #f2f9ff;
}

.main-without-padding {
  padding: 0 !important;
}

.main-menu {
  width: var(--menu-widh);
  height: calc(100%);
  position: relative;
  z-index: 101;
  box-sizing: border-box;
}
</style>
